// Odeslání kontaktního formuláře landing page na POST /api/contact (FR02 20261001_LandingPage/
// 002_Marketing, FR-10). Endpoint běží na stejném originu jako web (kopie routeru apps/functions
// nasazená s landing site), proto relativní cesta a žádné CORS. Odpověď se převádí na výsledek,
// se kterým formulář pracuje; tělo chyby se čte jen kvůli chybám polí u 400.

export const CONTACT_ENDPOINT = '/api/contact';

export type ContactSubmitResult =
  | { kind: 'ok' }
  | { kind: 'rate_limited' }
  | { kind: 'validation'; fieldErrors: Record<string, string[]> }
  | { kind: 'error' };

function readFieldErrors(body: unknown): Record<string, string[]> {
  if (typeof body !== 'object' || body === null) return {};
  const fieldErrors = (body as { fieldErrors?: unknown }).fieldErrors;
  if (typeof fieldErrors !== 'object' || fieldErrors === null) return {};
  const result: Record<string, string[]> = {};
  for (const [field, messages] of Object.entries(fieldErrors)) {
    if (Array.isArray(messages)) {
      const texts = messages.filter((message): message is string => typeof message === 'string');
      if (texts.length > 0) result[field] = texts;
    }
  }
  return result;
}

export async function submitContactForm(payload: Record<string, unknown>): Promise<ContactSubmitResult> {
  let response: Response;
  try {
    response = await fetch(CONTACT_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
      credentials: 'same-origin',
    });
  } catch {
    return { kind: 'error' };
  }

  if (response.status === 202) return { kind: 'ok' };
  if (response.status === 429) return { kind: 'rate_limited' };
  if (response.status === 400) {
    let body: unknown = null;
    try {
      body = await response.json();
    } catch {
      return { kind: 'error' };
    }
    return { kind: 'validation', fieldErrors: readFieldErrors(body) };
  }
  return { kind: 'error' };
}

/** UUID v4 odeslání formuláře (FR-01 `submissionId`). `crypto.randomUUID` jen v zabezpečeném kontextu. */
export function createSubmissionId(): string {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
